// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const drawerClasses = {
  content: "qui-drawer__content",
  positioner: "qui-drawer__positioner",
} as const
